(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anchor-topbar"] && !Shopify.designMode) return;
  try {
    

    let scrollX,scrollY,scrollDirection;
    function getScrollAction() {
      if (typeof scrollX == 'undefined') {
        scrollX = window.pageXOffset;
        scrollY = window.pageYOffset;
        scrollDirection = 'down';
      }
      var diffX = scrollX - window.pageXOffset;
      var diffY = scrollY - window.pageYOffset;
  
      if (diffX < 0) {
        // Scroll right
        scrollDirection = 'right';
      } else if (diffX > 0) {
        // Scroll left
        scrollDirection = 'left';
      } else if (diffY < 0) {
        // Scroll down
        scrollDirection = 'down';
      } else if (diffY > 0) {
        // Scroll up
        scrollDirection = 'up';
      }
      scrollX = window.pageXOffset;
      scrollY = window.pageYOffset;
    }
    var anchors = document.querySelectorAll("[data-anchor]")
    var placeholder = document.querySelector(".anchor-placeholder")
    if (!anchors.length) {
      return
    }

    var menu = document.querySelector('.anchor-placeholder .anchor-menu')
    anchors.forEach((node) => {
      menu.insertAdjacentHTML('beforeend', `<div class="anchor-item" data-target="${node.dataset.anchorId}">${node.dataset.anchor}</div>`); 
    })

    menu.querySelectorAll('.anchor-item').forEach((item) => {
      item.addEventListener('click', () => {
        var target = document.querySelector(`[data-anchor-id="${item.dataset.target}"]`)
        window.scrollTo({
          top: target.parentElement.offsetTop - placeholder.clientHeight,
          behavior: "smooth"
        });
      })
    })

    var productBtn = document.querySelector('.anchor-placeholder .anchor-button')
    if (productBtn) {
      var target = document.querySelector(`[data-anchor-product]`)
      if (target) {
        productBtn.removeAttribute('hidden')
        productBtn.addEventListener('click', () => {   
          window.scrollTo({
            top: target.parentElement.offsetTop,
            behavior: "smooth"
          });
        })
      } else {
        productBtn.parentElement.classList.add('anchor-menu-only')
      }
    }

    placeholder.classList.add('anchor-active')

    const h_anchor = placeholder.offsetHeight;

    window.onscroll = function() {
      getScrollAction();
      if (['left', 'right'].indexOf(scrollDirection) > -1) {
        return;
      }

      const h_header = document.querySelector('header.shopify-section-group-header-group').offsetHeight;
      //  var headerOpen = document.querySelector('details[open]')
      if (scrollY >= h_anchor) {
        if (scrollDirection == 'up') {
          placeholder.style.top = `${h_header}px`;
          placeholder.style.display = 'flex';
          placeholder.style.position = 'fixed';
          placeholder.style.zIndex = 9;
        } else {
          placeholder.style.top = 0;
          placeholder.style.position = 'fixed';
          placeholder.style.display = 'flex';
        //  placeholder.style.zIndex = headerOpen ? 9 : 11;
          placeholder.style.zIndex = 11;
        }
      } else {
        placeholder.style.display = 'none';
      }
    };

    window.addEventListener('scroll', function() {
      var anchorHeight = document.querySelector('.anchor-placeholder').clientHeight;
      var anchorItems = document.querySelectorAll('.anchor-placeholder .anchor-item');
      var offsetTop = window.pageYOffset + anchorHeight;

      anchorItems.forEach(function(ele) {
        var anchorId = ele.getAttribute('data-target');
        var targetNode = document.querySelector('[data-anchor-id="' + anchorId + '"]');
        // console.log(targetNode.parentElement.offsetTop, offsetTop)
        if ((targetNode.parentElement.offsetTop - anchorHeight) <= offsetTop) {
          anchorItems.forEach(function(item) {
            item.classList.remove('active');
          });
          ele.classList.add('active');
        }
      });
    });


  

  } catch(e) { console.error(e); }
})();
})();
